var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 119,
    viewBox: "0 0 131 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6803 46.6855H8.01252C7.31079 46.6855 6.75 47.2463 6.75 48.089L12.3617 114.734C12.5016 116.698 14.1859 118.241 16.1502 118.241H49.6829C51.6472 118.241 53.3306 116.698 53.4714 114.734L59.0831 48.089C58.9422 47.3873 58.3814 46.6855 57.6796 46.6855H57.6803Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1045 82.3224H128.137C129.26 82.3224 130.101 81.1998 129.961 80.0773C128.699 72.922 122.385 67.3093 114.808 67.3093H80.4337C72.8578 67.3093 66.5433 72.7812 65.2809 80.0773C65.1409 81.1999 65.9826 82.3224 67.1051 82.3224H67.1045Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.138 103.369H67.1051C65.9825 103.369 65.1409 104.492 65.2809 105.614C66.5434 112.77 72.8568 118.241 80.4337 118.241H114.808C122.384 118.241 128.699 112.77 129.961 105.614C130.242 104.351 129.4 103.369 128.138 103.369H128.138Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.426 87.6528H66.9727C65.9901 87.6528 65.1484 88.4945 65.1484 89.4771V96.2115C65.1484 97.1941 65.9901 98.0357 66.9727 98.0357H128.426C129.409 98.0357 130.25 97.194 130.25 96.2115V89.4771C130.25 88.4955 129.409 87.6528 128.426 87.6528Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0447 33.0753H34.8078V12.4506L46.874 4.59378C47.4348 4.17294 47.5757 3.47122 47.1549 2.91043L45.6114 0.525375C45.1906 -0.0354172 44.4889 -0.176348 43.9281 0.24449L30.5994 8.94312C29.8977 9.50391 29.3369 10.3466 29.3369 11.1882V33.3563H4.36269C2.25853 33.3563 0.574219 35.0397 0.574219 37.1448V37.9865C0.574219 40.0906 2.25757 41.775 4.36269 41.775H60.9054C63.0096 41.775 64.6939 40.0916 64.6939 37.9865V37.1448C64.8329 34.7598 63.1485 33.0755 61.0445 33.0755L61.0447 33.0753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventoryIcon.1644db2d580472069daf8d742786eb61.svg";
export { ForwardRef as ReactComponent };